<template>
  <content-panel style="margin: 0">
    <template v-slot:search>
      <!--搜索-->
      <search-box class="search-box">
        <el-form :inline="true" size="mini" label-width="70px" :model="searchForm" :rules="rules" ref="searchForm">
          <div class="search-row">
            <el-form-item label="文件名:" prop="employeeNo">
              <el-input v-model.trim="searchForm.folderName" placeholder="请输入文件名" @keyup.enter.native="onSearchList"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <template v-slot:right>
          <el-button class="green-btn" size="mini" @click="onSearchList">搜索</el-button>
          <el-button class="orange-btn" size="mini" @click="resetForm">重置</el-button>
        </template>
      </search-box>
    </template>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="mini" class="green-btn" @click="openUploadDialog">上传通栏图</el-button>
      </template>
      <template v-slot:header-right>
        <el-button type="primary" size="mini" class="green-btn" @click="uploadRecordsVisable = true">调整记录</el-button>
        <el-button type="primary" size="mini" class="green-btn" @click="bacthoPeration">下载</el-button>
      </template>
      <el-table
        @select="serlectRow"
        ref="tableRef"
        :height="maxTableHeight"
        border
        :data="tableData.records || []"
        :header-cell-style="{ backgroundColor: '#F4F8FB', textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        style="width: 100%"
        v-loading="loading"
        @sort-change="handleSortChange"
        @selection-change="handleSelectionChange"
        :row-key="
          (row) => {
            return row.id;
          }
        "
        element-loading-text="数据加载中..."
        element-loading-spinner="el-icon-loading"
      >
        <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
        <el-table-column label="预览" width="100">
          <template slot-scope="scope">
            <el-image
              v-if="scope.row.fileUrl"
              style="width: 79px; height: 52px"
              :src="scope.row.fileUrl"
              :preview-src-list="imgList"
              :initial-index="scope.$index"
              fit="cover"
            >
            </el-image>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="folderName" min-width="380" label="文件名">
          <template slot-scope="scope">
            <template v-if="scope.row.fileUrl">
              <el-link :underline="false" type="primary" @click="videoShow(scope.row, scope.$index)">{{ scope.row.folderName }}</el-link>
            </template>
            <template v-else>
              <el-link :underline="false" type="primary" @click="nextLayer(scope.row.id)">{{ scope.row.folderName }}</el-link>
            </template>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="listContent" label="上传清单" min-width="140">
          <template slot-scope="scope">
            <span
              v-if="scope.row.listContent && scope.row.listFileUrl"
              @click="handleDownload(scope.row.listFileUrl, scope.row.listContent)"
              style="color: #0bb78e; cursor: pointer"
            >
              {{ scope.row.listContent }}
            </span>
            <span v-else>{{ scope.row.listContent }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="updatedDate" label="上传时间" min-width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="noticeTime" label="通知时间" min-width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="name" label="上传人" min-width="70"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="type" label="类型" min-width="70">
          <template slot-scope="scope">{{ scope.row.type | typeText }}</template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="fileSize" label="大小" min-width="80"></el-table-column>
        <el-table-column label="操作" min-width="220" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" v-copy="scope.row.address" v-if="scope.row.address">复制地址</el-button>
            <el-button type="text" @click="edit(scope.row)" v-show="scope.row.type == 'folder'">修改</el-button>
            <el-button type="text" @click="rowDownLoad(scope.row)">下载</el-button>
            <el-button type="text" @click="openDeleteDialog(scope.row)" class="red-text-btn" v-permission="'ec-pc-new#filmRepairManagement#bannerImage'" v-show="scope.row.type == 'folder'">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-footer height="auto" style="text-align: right; padding: 5px 0">
        <el-pagination
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :current-page="tableData.pageNum"
          :page-sizes="[30, 100, 500, 1000]"
          :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="tableData.total"
        ></el-pagination>
      </el-footer>
    </table-panel>
    <!-- 查看图片弹窗 -->
    <el-dialog title="图片查看" :visible.sync="imgFormVisible" v-if="imgFormVisible" :close-on-click-modal="false" width="50%" v-esc-close
      ><imgShow :imgList="imgList" :imgIndex="imgIndex"></imgShow
    ></el-dialog>
    <!-- 调整记录 -->
    <upload-records :visible.sync="uploadRecordsVisable" :foldId="foldId" v-if="uploadRecordsVisable" />
    <!-- 上传/修改/删除通栏图弹窗 -->
    <upload-banner-dialog
      :visible.sync="uploadBannerVisible"
      :folderId="foldId"
      :dialogTitle="dialogTitle"
      :folderPath="folderPath"
      :fileType="fileType"
      :rowId="rowId"
      :mode="dialogMode"
      @complete="onUploadComplete"
      v-if="uploadBannerVisible"
    />
  </content-panel>
</template>
<script>
import imgShow from './imgShow';
import uploadRecords from './uploadRecords';
import uploadBannerDialog from './uploadBannerDialog';
import moment from 'moment';
import axios from '@/utils/axiosInstance';
import tableMixin from '@/utils/tableMixin';
import Tiff from 'tiff.js';
export default {
  name: 'fileManagement',
  components: { imgShow, uploadRecords, uploadBannerDialog },
  props: {
    folderPath: {
      type: String,
      default: '',
    },
  },
  mixins: [tableMixin],
  data() {
    return {
      tableHeight: null,
      loading: true,
      loadingAll: false,
      titleName: '',
      showFlag: false,
      searchForm: {},
      rules: {},
      requestParam: {},
      imgFormVisible: false,
      uploadRecordsVisable: false,
      uploadBannerVisible: false,
      dialogTitle: '上传通栏图',
      dialogMode: 'upload',
      imgList: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      model: [],
      maxHeight: 'auto',
      params: {
        headers: {
          'Content-Type': 'application/json;charset=utf-8', // 根据后台的接参数方式前端指定请求头
        },
      },
      radio: null,
      selectSpus: [],
      onRemoveSpuIds: [],
      queryCriteria: [],
      foldId: '',
      fliePath: '',
      errorNum: 0,
      tableRow: {},
      sortParams: {},
      searchFormData: {},
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: '',
        param: {},
        queryMatch: [],
        orderList: [ ],
        orderType: '',
        hasCount: 'N',
        groupAttr: '',
      },
      imgIndex: 0,
      fileType: '',
      rowId: ''
    };
  },
  computed: {},
  methods: {
    serlectRow(i, v) {
      this.model = i;
    },
    handleSelectionChange(val) {
      this.onRemoveSpuIds = [];
      console.log('val', val);
      val.forEach((x) => {
        this.onRemoveSpuIds.push(x.id);
      });
      this.selectSpus = val;
    },
    onSearch(foldId) {
      this.$refs.tableRef.clearSelection();
      this.foldId = foldId || this.foldId;
      this.tableData.pageNum = 1;
      this.init();
    },
    async init(type) {
      this.loading = true;
      let data = {
        filterData: {
          id: this.foldId,
          fileName: this.searchForm.folderName,
        },
        pageNum: this.tableData.pageNum,
        pageSize: this.tableData.pageSize,
      };
      this.$q.newProduct
        .fullWidthUploadGetCurrentLevelFolderAndFile({ data: data })
        .then((res) => {
          this.tableData = res.data;
          // 只提取有 fileUrl 的记录（文件），过滤掉文件夹
          this.imgList = res.data.records ? this.tableData.records.filter((v) => v.fileUrl).map((v) => v.fileUrl) : [];
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    videoShow(row, index) {
      this.imgFormVisible = true;
      // 计算正确的图片索引（只包含有 fileUrl 的记录）
      const fileRecords = this.tableData.records.filter((v) => v.fileUrl);
      const imgIndex = fileRecords.findIndex((v) => v.id === row.id);
      this.imgIndex = imgIndex >= 0 ? imgIndex : 0;
    },
    //针对于tiff格式处理展示
    async getTiffDataUrlHandler(url) {
      const response = await fetch(url);
      const buffer = await response.arrayBuffer();
      try {
        const tiff = new Tiff({ buffer: buffer });
        this.imgList = [tiff.toDataURL()];
      } catch (err) {
        this.getTiffDataUrlHandler(url);
      }
    },
    resetTableSort() {
      this.$refs.tableRef.clearSort();
    },
    onSearchList() {
      this.tableData.pageSize = 30;
      this.tableData.pageNum = 1;
      if (this.$refs.tableRef) {
        this.$refs.tableRef.clearSelection();
        this.$refs.tableRef.clearSort();
      }
      this.onSearch();
    },
    resetForm() {
      this.initSearchForm();
      this.onSearchList();
    },
    initSearchForm() {
      this.searchForm = {};
    },
    onSizeChange(pageSize) {
      this.tableData.pageNum = 1;
      this.tableData.pageSize = pageSize;
      this.loading = true;
      this.init(this.searchFormData);
    },
    onCurrentChange(pageNum) {
      this.tableData.pageNum = pageNum;
      this.loading = true;
      this.init(this.searchFormData);
    },
    getCaption(obj) {
      var index = obj.lastIndexOf('.'); //获取-后边的字符串
      obj = obj.substring(index + 1, obj.length);
      return obj;
    },
    rowDownLoad(row) {
      if (row.type === 'folder') {
        this.sliceDownload(row, false);
      } else {
        this.downLoadRequest(row.fileUrl, row.folderName);
      }
    },
    downLoadRequest(fileUrl, folderName, index) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      setTimeout((_) => {
        this.downloadRes(fileUrl, folderName);
        loading.close();
      }, 300);
    },
    
    async downloadRes(url, folderName, type) {
      let response = await fetch(url, { mode: 'cors' });
      let blob = await response.blob();
      let objectUrl = window.URL.createObjectURL(blob);
      let a = document.createElement('a');
      a.href = objectUrl;
      a.download = folderName + (type ? '.zip' : '');
      a.click();
      a.remove();
      // if (this.selectSpus.length == index + 1) {
      //   setTimeout(() => {
      //     this.loadingAll.close();
      //   }, 500);
      // }
    },
    async bacthoPeration() {
      if (!this.selectSpus.length) {
        this.$message.error('请选择后在进行操作');
        return;
      }
      this.sliceDownload(false, true);
    },
    sliceDownload(row, type) {
      const _this = this;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      var data = type ? this.selectSpus : [row];
      data = data.map((v) => {
        return {
          fileId: v.type == 'file' ? v.id : '',
          folderId: v.type == 'folder' ? v.id : '',
          type: v.type,
          path: v.address,
          folderName: v.folderName,
        };
      });
      this.$q.newProduct.fullWidthDownload({ data: data }).then((res) => {
        var timer = setInterval(function () {
          _this.$q.common
            .reportTaskInfo({ fragment: [res.message] })
            .then((res) => {
              if (res.data.taskStatus == '执行完成') {
                clearInterval(timer);
                loading.close();
                _this.downloadRes(res.data.filePath, res.data.taskDesc, true);
              }
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }, 5000);
      });
    },
    nextLayer(id) {
      this.$emit('expandNodeById', id);
      this.onSearch(id);
    },
    async del(row, type) {
      let status = await this.$confirm('确认删除当前文件？', '提示', { type: 'warning' });
      if (status !== 'confirm') return;
      var data = type ? this.selectSpus : [row];
      data = data.map((v) => {
        return {
          fileId: v.type == 'file' ? v.id : '',
          folderId: v.type == 'folder' ? v.id : '',
          type: v.type,
        };
      });
      this.$q.newProduct.sliceDelete({ data: data }).then((res) => {
        if (res.code == 200) {
          this.$message.success('删除成功');
          let type = !data.map((v) => v.type).includes('folder');
          this.$emit('getNewTree', this.foldId);
          this.onSearchList();
        }
      });
    },
    handleSortChange({ prop, order }) {
      this.sortParams = {
        type: order == 'ascending' ? 'asc' : order == 'descending' ? 'desc' : '',
        attributeName: prop,
      };
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 上传通栏图完成回调
    onUploadComplete() {
      this.onSearchList();
      this.$emit('getNewTree', this.foldId);
    },
    // 打开上传通栏图弹窗
    openUploadDialog() {
      this.dialogTitle = '上传通栏图';
      this.dialogMode = 'upload';
      this.uploadBannerVisible = true;
    },
    // 修改操作 - 打开修改通栏图弹窗
    edit(row) {
      this.dialogTitle = '修改通栏图';
      this.dialogMode = 'edit';
      this.uploadBannerVisible = true;
      this.rowId = row.id;
      this.fileType = row.type;
    },
    // 删除操作 - 打开删除提示弹窗
    openDeleteDialog(row) {
      this.dialogTitle = '删除提示';
      this.dialogMode = 'delete';
      this.rowId = row.id;
      this.fileType = row.type;
      this.uploadBannerVisible = true;
    },
    // 下载清单文件
    async handleDownload(url, fileName) {
      try {
        const loading = this.$loading({
          lock: true,
          text: '下载中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        const response = await fetch(url);
        const blob = await response.blob();
        const objectUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(objectUrl);
        loading.close();
      } catch (error) {
        this.$message.error('下载失败');
        console.error('下载失败:', error);
      }
    }
  },

  mounted() {
    // this.onSearch();
  },
  filters: {
    typeText(type) {
      if (type === 'folder') {
        return '文件夹';
      } else if (type === 'file') {
        return '文件';
      } else {
        return '';
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .content-panel {
  margin: 0 !important
}

>>> .el-dialog__headerbtn:hover .el-dialog__close{
  color: #FFF
}
</style>
